import PropTypes from "prop-types"
import { useContext, useEffect } from "react"
import LinearProgressLoader from "~/components/LinearProgressLoader"
import AppContext from "~/contexts/App"
import { useGetDoc } from "~/hooks/useGetDoc"
import NotFound from "~/pages/NotFound"
import Router from "~/router"

import Page from "~/pages/Page"

const Doc = ({ routes = [], ...rest }) => {
  const { setPageSubTitle } = useContext(AppContext)
  const { isLoading, data: doc } = useGetDoc(rest?.match?.params?.doc_id)

  useEffect(() => {
    setPageSubTitle("")
  }, [])

  return (
    <DocWrapper isLoading={isLoading} doc={doc}>
      <Page>
        <Router routes={routes} {...rest} />
      </Page>
    </DocWrapper>
  )
}
Doc.propTypes = {
  routes: PropTypes.array,
}

const DocWrapper = ({ isLoading, children, doc }) => {
  if (isLoading) {
    return <LinearProgressLoader />
  } else if (!doc) {
    return <NotFound />
  } else {
    return children
  }
}
DocWrapper.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
}

export default Doc
